import { FunctionComponent, memo, useEffect, useMemo, useState } from "react";

interface IProps {
}

const absCoordsFromProgressNoOffset = (progess: number, radius: number): { x: number, y: number } => {
	const radians = -2 * Math.PI * progess;
	const relX = Math.sin(radians) * radius;
	const relY = Math.cos(radians) * radius;
	return { x: relX, y: relY };
}

const absCoordsFromProgress = (progess: number, radius: number): { x: number, y: number } => {
	const { x: relX, y: relY } = absCoordsFromProgressNoOffset(progess, radius);
	const xOffset = 50;
	const yOffset = 50;
	return { x: xOffset - relX, y: yOffset - relY };
}

const speed = 1;
const animationLife = 1000 * speed;
const spf = 50;
const arcEnd = 900 * speed;

const triangleMeta = () => {
	return { c: Math.random(), d: Math.random() };
}

const ClickTriangles: FunctionComponent<IProps> = () => {
	const [triangleCenters] = useState((Math.random() > .5 ? [triangleMeta()] : []));
	const [t, setT] = useState(500);

	useEffect(() => {
		const move = () => {
			setT(t => t >= animationLife ? animationLife : t + spf);
		}
		const timeout = setTimeout(move, spf);
		return () => {
			clearTimeout(timeout);
		}
	}, [t]);

	let diameter = ((t / animationLife) * 100) + "%";
	let triangleSize = t > animationLife ? 0 : (t > arcEnd) ? 8 * (1 - ((t - arcEnd)/(animationLife - arcEnd))) : 8;

	const triangles = triangleCenters.map(({ c, d }) => {
		const center = absCoordsFromProgress(c, 40);
		const p0 = absCoordsFromProgressNoOffset(d + 0, triangleSize);
		const p1 = absCoordsFromProgressNoOffset(d + .333, triangleSize);
		const p2 = absCoordsFromProgressNoOffset(d + .667, triangleSize);
		return <polygon key={c} points={`${center.x + p0.x},${center.y + p0.y} ${center.x + p1.x},${center.y + p1.y} ${center.x + p2.x},${center.y + p2.y}`} 
			style={{ fill: "var(--colorful-loading-blue)" }}
		/>;
	});

	return <svg version="1.1" id="L7" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
		viewBox="0 0 104 104" enableBackground="new 0 0 100 100" xmlSpace="preserve" width={diameter} height={diameter}>
		<g fillOpacity={0.9}>
			{triangles}
		</g>
	</svg>;
}

export default memo(ClickTriangles);